import { Serializable, Serialized, SerializeUtil } from '../../../utils/serialize';
import { VerificationTokenType } from './verification-token-type.enum';

export interface BackEndVerificationToken {
  credentials_id: string;
  email: string;
  id: string;
  otp_secret: string;
  type: VerificationTokenType;
}

export class VerificationToken implements Serializable {
  @Serialized() public credentialsId: string;
  @Serialized() public email: string;
  @Serialized() public id: string;
  @Serialized() public otpSecret: string;
  @Serialized() public type: VerificationTokenType;

  public static deserialize(serialized: string | object): VerificationToken {
    const token = new VerificationToken();
    return SerializeUtil.deepDeserialize(token, serialized);
  }

  public static fromBackEnd(backEndVerificationToken: BackEndVerificationToken): VerificationToken {
    const token = new VerificationToken();
    token.credentialsId = backEndVerificationToken.credentials_id;
    token.email = backEndVerificationToken.email;
    token.id = backEndVerificationToken.id;
    token.otpSecret = backEndVerificationToken.otp_secret;
    token.type = backEndVerificationToken.type;
    return token;
  }

  public serialize(): string {
    return SerializeUtil.deepSerialize(this);
  }
}
